export default __webpack_public_path__ + "static/young-toddler11-91005ec040b8b1078176feb7d193cf2b.jpg";